module.exports = __webpack_public_path__ + "img/about2.a09c6ea3.jpg";